import API from "./API";
import SiteAPI from "./SiteAPI";
// import Alert from "../stores/alerts";
import app from "../stores/app";
import user from "../stores/user";
import {writable} from "svelte/store";

export const LOADER = {
    NONE: 0,
    PAGE: 1,
    POPUP: 2,
}

const mm = writable(false);

const R = {
    handle: async (func, params, success, failure, loader = 0) => {
        if (loader == LOADER.PAGE) {
            app.showPageLoader();
        } else if (loader == LOADER.POPUP) {
            app.showPopupLoader();
        }

        mm.set(true);
        //const [err, result] = await func(params);
        const result = await func(params);
        mm.set(false);

        if (loader == LOADER.PAGE) {
            app.hidePageLoader();
        } else if (loader == LOADER.POPUP) {
            app.hidePopupLoader();
        }

        if (result.error) {
            if (result.error.code == 'no_login') {
                // Alert.warning("Λογαριασμός", "Έχεις αποσυνδεθεί από τον λογαριασμό σου!");
                user.clearToken();
            }
            failure(result.error);
        } else {
            success(result.data);
        }
    },

    app: {
        login: (data) => API.POST(`login`, data),
        initialize: () => API.GET('initialize'),
        settingsLoad: () => API.GET('settings'),
        settingsEdit: (data) => API.POST(`settings/edit`, data),
    },

    agent: {
        index: () => API.GET('agents'),
        details: (id) => API.GET(`agent/${id}/details`),
        create: (data) => API.POST('agent/create', data),
        edit: (data) => API.POST(`agent/edit`, data),
        delete: (id) => API.POST('agent/delete', {id}),
    },

    reservation: {
        index: (data) => API.POST('reservations', data),
        dayIndex: (data) => API.POST('reservations/day', data),
        monthSummary: (data) => API.POST('reservation/month-summary', data),
        details: (id) => API.GET(`reservation/${id}/details`),
        create: (data) => API.POST('reservation/create', data),
        edit: (data) => API.POST(`reservation/edit`, data),
        delete: (id) => API.POST('reservation/delete', {id}),
        sendMail: (data) => API.POST(`reservation/send-mail`, data),
    },

    stopSale: {
        index: () => API.GET('stop-sales'),
        // toggle: (date_at) => API.POST('stop-sales/toggle', {date_at}),
        save: (data) => API.POST(`stop-sales/save`, data),
    },

    review: {
        index: (data) => API.POST('reviews', data),
        details: (id) => API.GET(`review/${id}/details`),
        create: (data) => API.POST('review/create', data),
        edit: (data) => API.POST(`review/edit`, data),
        delete: (id) => API.POST('review/delete', {id}),
    },

    user: {
        index: (data) => API.POST('users', data),
        details: (id) => API.GET(`user/${id}/details`),
        create: (data) => API.POST('user/create', data),
        edit: (data) => API.POST(`user/edit`, data),
        delete: (id) => API.POST('user/delete', {id}),
    },

    settings: {
        index: () => API.GET('settings'),
        edit: (data) => API.POST(`settings/edit`, data),
    },
};

export default R;
export {mm as requestingStore};